'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _copy = require('./copy.html');

var _copy2 = _interopRequireDefault(_copy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _copy2.default,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    copyAreas: '<',
    isTreat: '<',
    onCopied: '&'
  },
  controller: function () {
    function CopyComponent(EventEmitter, ProductService) {
      'ngInject';

      _classCallCheck(this, CopyComponent);

      Object.assign(this, { EventEmitter: EventEmitter, ProductService: ProductService });
    }

    _createClass(CopyComponent, [{
      key: 'searchProductsByNameForCopy',
      value: function searchProductsByNameForCopy(name, isTreat) {
        return this.ProductService.searchProductsByNameForCopy(name, isTreat).then(function (p) {
          return p.data;
        });
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        this.onCopied(this.EventEmitter({
          product: this.selectedProduct,
          copyAreas: this.selectedCopyAreas
        }));
      }
    }]);

    return CopyComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/product/copy/copy.component.js